// 退款状态
export const REFUND_STATUS = {
  1: "待处理",
  2: "同意退款",
  3: "拒绝退款",
};
// 交易状态
export const TRADE_STATUS = {
  1: "待支付",
  2: "支付成功",
  3: "订单关闭", // 超时未支付
  4: "已取消",
  5: "交易完成",
};
export const ORDER_STATE = {
  1: "未支付",
  2: "已支付",
  3: "已超时",
  4: "已取消",
};
// 支付类型
export const PAY_TYPE = {
  alipay: "支付宝支付", //支付宝 App 支付
  alipay_wap: "支付宝支付", //支付宝手机网站支付
  alipay_qr: "支付宝支付", //支付宝扫码支付
  alipay_scan: "支付宝支付", //支付宝条码支付
  alipay_lite: "支付宝支付", //支付宝小程序支付
  alipay_pc_direct: "支付宝支付", //支付宝电脑网站支付
  wx: "微信支付", //微信 App 支付
  wx_pub: "微信支付", //微信 JSAPI 支付
  wx_pub_qr: "微信支付", //微信 Native 支付
  wx_pub_scan: "微信支付", //微信付款码支付
  wx_wap: "微信支付", //微信 H5 支付
  wx_lite: "微信支付", //微信小程序支付
  qpay: "QQ 钱包 App 支付",
  qpay_pub: "QQ 钱包公众号支付",
  upacp: "银联手机控件支付（银联 App 支付）",
  upacp_pc: "银联网关支付（银联 PC 网页支付）",
  upacp_qr: "银联二维码（主扫）",
  upacp_scan: "	银联二维码（被扫）",
  upacp_wap: "银联手机网站支付",
  upacp_b2b: "银联企业网银支付（银联 B2B PC 网页支付）",
  cp_b2b: "银联电子企业网银支付（银联电子 B2B PC 网页支付）",
  applepay_upacp: "Apple Pay",
  cmb_wallet: "招行一网通",
  cmb_pc_qr: "招行 PC 扫码支付",
  bfb_wap: "百度钱包",
  jdpay_wap: "京东支付",
  yeepay_wap: "易宝支付",
  isv_qr: "线下扫码（主扫）",
  isv_scan: "线下扫码（被扫）",
  isv_wap: "线下扫码（固定码）",
  isv_lite: "线下小程序支付",
  ccb_pay: "建行 App 支付",
  ccb_qr: "建行二维码支付",
  cmpay: "移动和包支付",
  coolcredit: "库分期",
  cb_alipay: "跨境支付宝 App 支付",
  cb_alipay_wap: "跨境支付宝手机网站支付",
  cb_alipay_qr: "跨境支付宝扫码支付",
  cb_alipay_scan: "跨境支付宝条码支付",
  cb_alipay_pc_direct: "跨境支付宝电脑网站支付",
  cb_wx: "跨境微信 App 支付",
  cb_wx_pub: "跨境微信 JSAPI 支付",
  cb_wx_pub_qr: "跨境微信 Native 支付",
  cb_wx_pub_scan: "跨境微信付款码支付",
  paypal: "PayPal",
  balance: "余额",
  yeepay_wx_pub_qr: "微信支付", //易宝- 微信 native 支付
  yeepay_wx_pub: "易宝 - 微信公众号支付",
  yeepay_wx_pub_ofl: "易宝 - 微信公众号支付(线下)",
  yeepay_wx_lite: "微信支付", //易宝 - 微信小程序支付
  yeepay_wx_lite_ofl: "微信支付", //易宝 - 微信小程序支付
  yeepay_wx_pub_scan: "微信支付", //易宝 - 微信付款码支付
  yeepay_alipay_qr: "支付宝支付", //易宝 - 支付宝扫码支付
  yeepay_alipay_lite: "支付宝支付", //易宝 - 支付宝小程序支付
  yeepay_alipay_pub: "支付宝支付",//易宝 - 支付宝生活号支付
  yeepay_alipay_scan: "支付宝支付",//易宝 - 支付宝条码支付
  yeepay_upacp_qr: "易宝 - 银联二维码（主扫）支付",
  yeepay_upacp_scan: "易宝 - 银联二维码（被扫）支付",
};
